import React, { useEffect } from "react";
import { Grid, InputAdornment, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useEquipment, useUser } from "@services/servicesGenericsTables";
import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilterSamplingProcedure from "@app/hooks/useFilterSamplingProcedure";
import useAuth from "@app/context/AuthContext";
import { formatDateOrNow } from "@app/utils/formatDate";

const Digestion = () => {
  const form = useFormContext();
  const { equipmentList } = useEquipment();
  const { userList } = useUser();
  const filterSamplingProcedureList = useFilterSamplingProcedure("DIGEST");
  const { user } = useAuth();

  useEffect(() => {
    if (!form.getValues("processing_analyst_digestion")) {
      form.setValue("processing_analyst_digestion", user);
      form.setValue("processing_date_time_digestion", formatDateOrNow());
      form.setValue(
        "processing_procedure_digestion",
        filterSamplingProcedureList[0] || undefined
      );
    }
  }, []);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{"Digestión"}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={5} mt={1}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_analyst_digestion"))}
          name="processing_analyst_digestion"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_procedure_digestion"))}
          name="processing_procedure_digestion"
          options={filterSamplingProcedureList}
          label="Procedimiento MLPMA"
          getOptionLabel={(option) => `${option.numop}` || ""}
          validation={{
            required:
              filterSamplingProcedureList.length > 0
                ? "El procedimiento MLPMA es requerido"
                : false,
          }}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_equipment_digestion"))}
          name="processing_equipment_digestion"
          options={equipmentList}
          label="Seleccione un Equipo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}` || ""
          }
          validation={{ required: "El equipo es requerido" }}
          multiple={true}
        />
        <MDatePicker
          name="processing_date_time_digestion"
          pickerType="datetime"
          label="Fecha y hora Inicio"
          validation={{ required: "La fecha y hora de inicio es requerida" }}
        />

        <MTextField
          key={JSON.stringify(form.getValues("sample_quantity_digestion"))}
          name="sample_quantity_digestion"
          placeholder="Cantidad muestra"
          label="Cantidad muestra"
          type="number"
          fullWidth
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default Digestion;
